import { isMobile, isSmartphone, isTouch } from '../_app/cuchillo/core/Basics';
import { C, GetBy } from '../_app/cuchillo/core/Element';
import { Interaction } from '../_app/cuchillo/core/Interaction';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { Sizes } from '../_app/cuchillo/core/Sizes';
import InterfaceCanvas from '../_app/cuchillo/layout/InterfaceCanvas';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { CSS } from '../_app/cuchillo/utils/CSS';
import { Maths } from '../_app/cuchillo/utils/Maths';
import Home from '../pages/Home';
import gsap, { Power2 } from 'gsap';


export default class InfiniteScroll__ArtistItem extends InfiniteScroll__Item {
    indice;
    video;
    _src

    constructor(__d, __i, __axis = InfiniteScroll.AXIS_Y) {
        super(__d, __i, __axis, true);

        this._isPlay = false;
        this.indice = this.index;
        this.video = GetBy.selector("video", this.dom)[0];
        this._src = this.video?.getAttribute('src');
    }

    drawHook() {
        if (!this.video) return;
        this.move();
    }


    play() {
        if (this._isPlay) return;

        this._isPlay = true;
        this.video.src = this._src;  // asignamos src aquí
        this.video.preload = 'auto';
        this.video.play();
    }

    pause() {
        if (!this._isPlay) return;
        this._isPlay = false;
        this.video.pause();
        this.video.src = '';
        this.video.load();
    }

    move() {
        if (this.progressInside >= 0 && this.progressInside < 1) {
            this.play();
        } else {
            this.pause();
        }
    }

    dispose() {
        super.dispose();
        this.pause();
        this.video = null;
        this._src = null;
    }
}
